module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-15",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "wrapper-preview-container shadow",
    style: ({
      height: _vm.previewCardHeight + 'px'
    })
  }, [_c('div', {
    ref: "previewCardWrapper",
    staticClass: "wrapper-preview",
    style: ({
      transform: 'scale(' + _vm.previewCardScale + ')'
    })
  }, [_c('page-card-content', {
    ref: "previewCard",
    attrs: {
      "title": _vm.title,
      "message": _vm.message,
      "province": _vm.province,
      "school": _vm.school,
      "owner": _vm.owner,
      "previewSrc": _vm.previewSrc
    }
  })], 1), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "form__file"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onSelectFile
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "preview-edit"
  }, [(_vm.showEditLink && !_vm.editMode) ? _c('a', {
    staticClass: "pull-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.edit.apply(null, arguments)
      }
    }
  }, [_vm._v("แก้ไข")]) : _vm._e(), _vm._v(" "), (_vm.showEditLink && _vm.editMode) ? _c('a', {
    staticClass: "pull-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel.apply(null, arguments)
      }
    }
  }, [_vm._v("ยกเลิก")]) : _vm._e()])])]), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "capture-image-wrapper"
  }, [_c('div', {
    ref: "captureCard",
    staticClass: "capture-image"
  }, [_c('page-card-content', {
    ref: "capturePageCard",
    attrs: {
      "title": _vm.title,
      "message": _vm.message,
      "province": _vm.province,
      "school": _vm.school,
      "owner": _vm.owner,
      "previewSrc": _vm.previewSrc
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "captureCanvas",
    staticClass: "capture-canvas"
  }, [_vm._v("\n        canvas here\n      ")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fas-wrapper"
  }, [_c('i', {
    staticClass: "fas fa-camera"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44c221c0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageCard.vue
// module id = 1141
// module chunks = 0